import React from "react";
import { FaBriefcase } from "react-icons/fa";
import "./experience.css";
import { LuBookOpen } from "react-icons/lu";
import { IoSchool } from "react-icons/io5";

export default function Experience() {
  const experiences = [
    {
      title: "Open Source Contributor at Mifos Initiative",
      company: "Google Summer Of Code 2023",
      startDate: "May 2023",
      endDate: "August 2023",
      description:
        "Worked on full-stack development based project in Angular, Kotlin, Java and Docker.Successfully completed internationalisation to the website and implemented monorepo architecture and micro-frontend part for better collaboration.",
    },
    {
      title: "Software Developer",
      company: "Wavel.ai",
      startDate: "May 2023",
      endDate: "Present",
      description:
        "Designed engaging pages boosting user management by 2x and decreased server response time by 10%.Applied agile methods to meet deadlines, optimized the website, increased good health score and speed",
    },
    {
      title: "Software Developer Intern",
      company: "Itanta Analytics",
      startDate: "November 2022",
      endDate: "April 2023",
      description:
        "Developed data handling android application in Angular/Ionic also deployed to make it use to android and mac users.Successfully completed the phases of requirement gathering, designing, tech-learning, implementation and deployment in the internship period.",
    },
    {
      title: "Full Stack Developer Intern",
      company: "Clodura.AI",
      startDate: "February 2022",
      endDate: "November 2022",
      description: "Developed frontend applications using React and Redux.",
    },
  ];
  const educations = [
    {
      title: "Education",
      degree: "Bachelor of Technology",
      institution: "Vishwakarma Institute of Technology",
      startDate: "2019",
      endDate: "2023",
      description: "Bachelors of Technology - 8.87",
    },
  ];
  const skills = [
    { name: "JavaScript", class: "js" },
    { name: "React", class: "react" },
    { name: "Angular", class: "angular" },
    { name: "C++", class: "cpp" },
    { name: "Java", class: "java" },
    { name: "Python", class: "python" },
    { name: "HTML5", class: "html5" },
    { name: "CSS3", class: "css3" },
  ];
  return (
    <>
      <div className="">
        <div className="listexp">
          <div className="image-text">
            <div className="img-icon">
              <FaBriefcase
                className="icons"
                style={{ color: "hsl(45, 100%, 72%)" }}
              />
            </div>
            <h3>Open Source Contributor at Mifos Initiative</h3>
          </div>
          {experiences.map((experience, index) => (
            <ol key={index} className="timeline-list">
              <li className="timeline-item">
                <h4 className="h4 timeline-item-title">{experience.company}</h4>
                <span>
                  {experience.title} | {experience.startDate} -{" "}
                  {experience.endDate}
                </span>
                <p className="timeline-text">- {experience.description}</p>
              </li>
            </ol>
          ))}
        </div>
      </div>

      <div className="">
        <div className="mt-5">
          {educations.map((education, index) => (
            <div key={index} className="listexp">
              <div className="image-text">
                <div className="img-icon">
                <LuBookOpen                     className="icons"
                    style={{ color: "hsl(45, 100%, 72%)" }}
                  />
                </div>
                <h3>{education.title}</h3>
              </div>
              <ol className="timeline-list">
                <li className="timeline-item">
                  <h4 className="h4 timeline-item-title">
                    {education.institution}
                  </h4>
                  <span>
                    {education.title} | {education.startDate} -{" "}
                    {education.endDate}
                  </span>
                  <p className="timeline-text">- {education.description}</p>
                </li>
              </ol>
            </div>
          ))}
        </div>
      </div>
      <section className="skills-section">
        <h3 className="h3 clients-title">
        <div className="img-icon">
        <IoSchool                 className="icons"
                style={{ color: "hsl(45, 100%, 72%)" }}
              />
            </div>
            My Skills</h3>
        <div className="skills-grid">
          {skills.map((skill, index) => (
            <div key={index} className={`skill-card ${skill.class}`}>
              {skill.name}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
